import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, RadioValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class RadioHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const arr = [];
    const rv = (qc.value as RadioValue);
    return [{
      'FilterField': qc.fieldCode,
      'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Equal,
      'Value': rv.value,
      'Relation': (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And,
      'Expresstype': ValueType.Value,
      'Lbracket': qc.Lbracket || null,
      'Rbracket': qc.Rbracket || null
    }];
  }
}
